


























import Vue from 'vue';
import Component from 'vue-class-component';
import FormNavigationButtons from '../common/FormNavigationButtons.vue';
import ItemList from '../common/ItemList.vue';
import Tape from './ItemTape.vue';
import { Watch, Prop } from 'vue-property-decorator';
import { Tickets } from '@/modules/shared/shared/domain/constants/constants';
@Component({
    components: {
        FormNavigationButtons,
        ItemList,
        Tape,
    },
})
export default class StepTapes extends Vue {
    @Prop({ required: true })
    ticketSubjectSelected!: number;

    isFormValid: boolean = true;
    $refs!: {
        form: any;
        list: any;
    };
    tapes: {
        giveOrTake: string;
        code: string;
    }[] = Array();

    sendData() {
        this.updateListData();
        return {
            tapes: this.tapes.sort((a, b) => b.giveOrTake.length - a.giveOrTake.length),
        };
    }

    updateListData() {
        this.tapes = Array();
        this.$refs.list.requestData();
    }

    receiveData(data: any) {
        this.tapes.push(data);
    }

    validateStep() {
        if (this.ticketSubjectSelected === Tickets.REQUIREMENT.typings.tapeChange.id) {
            if (this.$refs.form.validate()) {
                this.$emit('nextStep');
            }
        } else {
            this.$emit('nextStep');
        }
    }

    previousStep() {
        this.$emit('previousStep');
    }
}
